// https://codesandbox.io/p/sandbox/react-d3-gauge-gwebx?file=%2Fsrc%2Fcomponents%2FGauge%2Fcomponents%2FLabel%2FLabel.js
import React, { useState } from "react";
import styled from "styled-components";
import * as d3 from "d3";
import { createSearchParams, useNavigate } from "react-router-dom";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position:relative;
`;

const Title = styled.div`
  font-size: var(--font-size, 12px);
  margin-top: 2px;
`;

const Label = styled.div`
  top: ${(props) => props.top}px;
  position: absolute;
  font-family: "AllianceNo2-SemiBold" !important;
  font-weight: 100;
  font-size: 16px;
  cursor: ${(props) => props.isLink ? 'pointer' : 'initial'};
  &:hover{
    text-decoration: ${(props) => props.isLink ? 'underline' : 'none'};
  }
`;

const baseRatio = 0.8;
/** Resolution of arc. */
const length = 40;

const GaugeArc = ({ maxAngle, minAngle, center, min = 0, max = 100, inset = 0, stroke, strokeWidth }) => {
  /** Calculate max angle of arc from degrees to radians */
  const maxRatio = maxAngle / 180;
  const arcMax = Math.PI * maxRatio;

  /** Calculate min angle of arc from degrees to radians */
  const minRatio = minAngle / 180;
  const arcMin = Math.PI * minRatio;

  /** Linear map from [0,1] to [-135,135] degrees in radians */
  const refToRads = d3.scaleLinear().domain([0, 100]).range([arcMin, arcMax]);

  /** Render scale to map [0,length - 1] to [minAndle, maxAngle] for rendering */
  const arcScale = d3
    .scaleLinear()
    .domain([0, length - 1])
    .range([refToRads(min), refToRads(max)]);

  /** Actual path function to generate path. */
  const arc = d3.lineRadial()
    .angle((d, i) => arcScale(i))
    .radius((87 * baseRatio) / 2 - inset);

  const arcPath = arc({ length });

  return (
    <path
      className="guage-arc"
      d={arcPath}
      transform={`translate(${center.x},${center.y})`}
      fill="transparent"
      style={{
        transition: "all 0.25s 0.25s",
        stroke,
        strokeWidth
      }}
    />
  );
};

const GaugeChart = ({ width, height, maxAngle = 135, minAngle = -135, viewLink="", title, strokeWidth=9, value=0, returnView }) => {
  const navigate = useNavigate();

  const gaugeOrigin = {
    x: width/2,
    y: height/2,
  };

  const handleClick = ()=>{
    if(viewLink){
      navigate({
        pathname: viewLink,
        search: createSearchParams({
          returnView: returnView,
        }).toString(),
      })
    }
  };

  return (
    <Wrapper>
      <svg width={width} height={height}>
        <g width={width} height={height}>
          <GaugeArc
            stroke={"var(--signal-grey-light, #f5f5f5)"}
            strokeWidth={strokeWidth}
            center={gaugeOrigin}
            maxAngle={maxAngle}
            minAngle={minAngle}
          />
          <GaugeArc
            stroke={"var(--signal-green, #00ba07)"}
            strokeWidth={strokeWidth}
            center={gaugeOrigin}
            maxAngle={maxAngle}
            minAngle={minAngle}
            max={value}
          />
        </g>
      </svg>
      <Label
        top={gaugeOrigin.y - 9}
        onClick={handleClick}
        isLink={viewLink !== ""}
      >
        {`${value}%`}
      </Label>
      {title ? <Title>{title}</Title> : null}
    </Wrapper>
  );
};

export default GaugeChart;
